export default __webpack_public_path__ + "static/media/413310__tieswijnen__select.cb31a0ce.mp3";